import { cs } from '../../../lib/currency';
/**
 * Tournament overview stats + age categories strip (iter271 — extracted
 * from TournamentDetail.js).
 *
 * Renders the 5-card stats grid (Registered / Paid / Unpaid / Collected /
 * Teams) and the Age Categories + Division/Play-Up flags strip directly
 * below it. All inputs are pre-computed by the parent page so this stays
 * purely presentational.
 */
import { Card, CardContent } from '../../ui/card';
import { Badge } from '../../ui/badge';
import {
  Users, CheckCircle, XCircle, DollarSign, Shield,
} from 'lucide-react';

export default function TournamentStats({
  tournament,
  totalRegistered,
  paidCount,
  unpaidCount,
  totalCollected,
  teamsCount,
}) {
  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        <Card><CardContent className="p-4"><div className="flex items-center gap-2"><Users className="h-5 w-5 text-blue-600" /><div><p className="text-sm text-slate-500">Registered</p><p className="text-2xl font-bold" data-testid="tournament-stat-registered">{totalRegistered}</p></div></div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="flex items-center gap-2"><CheckCircle className="h-5 w-5 text-green-600" /><div><p className="text-sm text-slate-500">Paid</p><p className="text-2xl font-bold text-green-600" data-testid="tournament-stat-paid">{paidCount}</p></div></div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="flex items-center gap-2"><XCircle className="h-5 w-5 text-red-600" /><div><p className="text-sm text-slate-500">Unpaid</p><p className="text-2xl font-bold text-red-600" data-testid="tournament-stat-unpaid">{unpaidCount}</p></div></div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="flex items-center gap-2"><DollarSign className="h-5 w-5 text-green-600" /><div><p className="text-sm text-slate-500">Collected</p><p className="text-2xl font-bold text-green-600" data-testid="tournament-stat-collected">{cs()}{totalCollected.toFixed(2)}</p></div></div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="flex items-center gap-2"><Shield className="h-5 w-5 text-purple-600" /><div><p className="text-sm text-slate-500">Teams</p><p className="text-2xl font-bold" data-testid="tournament-stat-teams">{teamsCount}</p></div></div></CardContent></Card>
      </div>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-sm font-medium text-slate-500">Age Categories:</span>
            {tournament.age_categories && tournament.age_categories.length > 0 ? (
              tournament.age_categories.map((cat) => (
                <Badge key={cat} variant="outline">{cat.toUpperCase()}</Badge>
              ))
            ) : (
              <Badge variant="outline" className="bg-slate-100 text-slate-600">OPEN</Badge>
            )}
            <span className="text-sm text-slate-500 ml-4">
              Registration Fee: <strong>{cs()}{tournament.initial_payment_amount}</strong>
            </span>
          </div>
          <div className="flex items-center gap-2 flex-wrap mt-3 pt-3 border-t">
            {tournament.is_division_based && (
              <>
                <Badge variant="outline" className="bg-purple-50 text-purple-700 border-purple-200">
                  <Shield className="h-3 w-3 mr-1" />Division-Based Tournament
                </Badge>
                {tournament.divisions?.map((div) => (
                  <Badge key={div} variant="secondary" className="text-xs">{div}</Badge>
                ))}
              </>
            )}
            {tournament.allow_play_up && (
              <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
                Play-Up Registration Allowed
              </Badge>
            )}
          </div>
        </CardContent>
      </Card>
    </>
  );
}
